define([
	"underscore",
	"csi/def",
	"csi/def/ActionFactory",
	"csi/def/ViewRef",
	"csi/prefs",
	"./_CustomViewAction"
], function(_, def, ActionFactory, ViewRef, csiPrefs, _CustomViewAction) {
	return ActionFactory.declare("CustomViewSaveAs", _CustomViewAction, {
		// set forceDuplicate to true
		classControllerParams: {
			forceDuplicate: true,
		},

		constructor() {
			if (!csiPrefs.hasPersonalAccess()) {
				// if no personal custom view editor, pop up a Form instead
				this.classController = "csi/view/customview/SaveAsController";
			}

			this.m_viewRef = _.extend(new ViewRef(), { m_id: def.DEFAULT_FORM_ID });
		},
	});
});